import { BellRingIcon } from './BellRingIcon';

/**
 * author: Google
 * id CD75C484-B1AD-492B-8CAA-9F002398C3CA
 * name bell-ring
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bell-ring.svg
 * tags
 * - Notification 
 */
export const NotificationsActiveIcon = BellRingIcon;
export default NotificationsActiveIcon